import { Empty, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import httpclient from "../../../../service/httpclient";
import moment from "moment";
import "./my_courses.scss";
import StreamingCourses from "../my_live/streaming_courses";
import {
  FEATURE_GATES,
  useFeatureGate,
} from "../../../../feature-gates/FeatureGateContext";

function MyCourses() {
  const history = useHistory();
  const location = useLocation();
  const separateLive = useFeatureGate(FEATURE_GATES.MY_LIVE_PAGE);
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    httpclient.getCourses().then((response) => {
      setCourses(response);
    });
  }, []);

  const columnCourses = (
    <div className="my-courses-content">
      {courses.length !== 0 ? (
        <>
          {courses.map((course) => (
            <div className="course" key={course.id}>
              <div style={{ display: "flex", marginRight: "10px" }}>
                <NavLink to={course.endpoint}>
                  <img
                    className="course-image"
                    src={course.image}
                    alt={course.name}
                  />
                </NavLink>
                <div
                  style={{
                    padding: "20px 0",
                    display: "flex",
                    justifyContent: "space-around",
                    flexFlow: "column",
                    marginLeft: "20px",
                  }}
                >
                  <NavLink to={course.endpoint}>
                    <div style={{ color: "black" }} className="course-name">
                      {course.name}
                    </div>
                  </NavLink>
                  {course.expire_time && (
                    <div className="expire-time-notification">
                      到期时间：
                      {moment
                        .utc(course.expire_time)
                        .local()
                        .format("YYYY-MM-DD")}{" "}
                      {moment(course.expire_time).isBefore(moment())
                        ? "(已过期)"
                        : "(未过期)"}
                    </div>
                  )}
                </div>
              </div>
              <NavLink
                to={`/checkout${course.endpoint}/renew`}
                className={"renew-button"}
              >
                <div>续费</div>
              </NavLink>
            </div>
          ))}
        </>
      ) : separateLive ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="空空如也" />
      ) : null}
    </div>
  );

  const activeTab =
    new URLSearchParams(location.search).get("tab") === "live"
      ? "live"
      : "columns";
  const changeTab = (key) => {
    const params = new URLSearchParams(location.search);
    if (key === "live") params.set("tab", "live");
    else params.delete("tab");
    history.replace({
      ...location,
      search: params.toString() ? `?${params}` : "",
    });
  };

  return (
    <div
      className={`my-courses-wrapper${separateLive ? " has-course-tabs" : ""}`}
    >
      {!separateLive && <div className="my-courses-title">我的课程</div>}
      {separateLive ? (
        <Tabs
          className="my-courses-tabs"
          activeKey={activeTab}
          onChange={changeTab}
        >
          <Tabs.TabPane tab="专栏" key="columns">
            {columnCourses}
          </Tabs.TabPane>
          <Tabs.TabPane tab="直播" key="live">
            <StreamingCourses />
          </Tabs.TabPane>
        </Tabs>
      ) : (
        <>
          {columnCourses}
          <StreamingCourses legacy showEmpty={courses.length === 0} />
        </>
      )}
    </div>
  );
}

export default MyCourses;
